import React from "react";
import { CardContent, Typography } from "@material-ui/core";
import { GenericLoader } from "../../../shared/widgets";

function CommonCardContent(props) {
  const {
    cardKey, classes, data, gridStrings, isLoading,
  } = props;
  return (
    <CardContent className={classes.cardContentWrapper}>
      <div className={classes.textIconWrapper}>
        <Typography className={classes.title} variant="h5">
          {gridStrings[cardKey].displayName}
        </Typography>
      </div>
      {gridStrings[cardKey].displayName === "Settled Amount" ? (
        <div>
          {(isLoading && (
            <div>
              <Typography className={classes.content} variant="h3">
                <GenericLoader />
              </Typography>
              <div className={classes.secondTextIconWrapper}>
                <Typography className={classes.secondTitle} variant="h7" />
              </div>
            </div>
          )) || (
            <div>
              <div className={classes.secondTextWrapper}>
                <Typography className={classes.secondSettlementTitle} variant="h7">
                  {`Paid : ${(data.paidSettledAmount
                        && data.paidSettledAmount.toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        }))
                        || 0
                  }`}
                </Typography>
              </div>
              <div className={classes.secondTextWrapper}>
                <Typography className={classes.secondSettlementTitle} variant="h7">
                  {`Received : ${(data.receiveSettledAmount
                        && data.receiveSettledAmount.toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        }))
                        || 0
                  }`}
                </Typography>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>
          <Typography className={classes.content} variant="h3">
            {(isLoading && <GenericLoader />) || (gridStrings[cardKey].displayName === "Money Loaded" && ((data.moneyLoaded + data.cardFeeCash).toLocaleString(undefined, { maximumFractionDigits: 2 }) || 0)) || ((data[cardKey]
                  && data[cardKey].toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                  }))
                  || 0)}
          </Typography>
          <div className={classes.secondTextIconWrapper}>
            <Typography className={classes.secondTitle} variant="h7">
              {(gridStrings[cardKey].displayName === "Last Balance" && "12 sep 2020") || ""}
            </Typography>
          </div>
        </div>
      )}
    </CardContent>
  );
}

export default CommonCardContent;
